import { createSlice } from "@reduxjs/toolkit";

export const mailSlice = createSlice({
  name: "mail",
  initialState: {
    sendLoading: false,
    sendError: false,
    sendMessage: "",
    sendStatusCode: null,
  },
  reducers: {
    onSendMail: (state) => ({
      ...state,
      sendLoading: true,
      sendError: false,
      sendMessage: "",
      sendStatusCode: null,
    }),
    onSendMailSuccess: (state, { payload }) => {
      const { message = "Mail sent successfully", status_code = 200 } =
        payload ?? {};
      return {
        ...state,
        sendLoading: false,
        sendError: false,
        sendMessage: message,
        sendStatusCode: status_code,
      };
    },
    onSendMailError: (state, { payload }) => {
      const { message = "Failed to send mail", status_code = 400 } =
        payload ?? {};
      return {
        ...state,
        sendLoading: false,
        sendError: true,
        sendMessage: message,
        sendStatusCode: status_code,
      };
    },
    onSendMailReset: (state) => ({
      ...state,
      sendLoading: false,
      sendError: false,
      sendMessage: "",
      sendStatusCode: null,
    }),
  },
});

export const {
  onSendMail,
  onSendMailSuccess,
  onSendMailError,
  onSendMailReset,
} = mailSlice.actions;

export default mailSlice.reducer;
